<template>
    <div class="login-container">
        <div class="login-bg-wave"></div>
        <div class="login-glow glow-1"></div>
        <div class="login-glow glow-2"></div>

        <!-- 左侧品牌区 -->
        <div class="login-left">
            <div class="login-brand">
                <div class="login-logo"><img src="/logo.png" alt="桨刻" /></div>
                <div>
                    <div class="login-brand-name">桨刻体育</div>
                    <div class="login-brand-sub">JIANGK SPORTS</div>
                </div>
            </div>
            <h1 class="login-slogan">让每一位龙舟运动员<br />被看见</h1>
            <p class="login-intro">赛事管理 · 报名审核 · 运动员档案 · 成绩积分<br />一站式龙舟赛事数据资产平台</p>
            <p class="login-contact">试用请致电：86-13168677659</p>
            <div class="login-points">
                <div class="login-point"><a-icon type="flag" /> 赛事全流程管理</div>
                <div class="login-point"><a-icon type="team" /> 运动员注册与档案</div>
                <div class="login-point"><a-icon type="trophy" /> 三种模式积分排名</div>
            </div>
        </div>

        <!-- 右侧登录卡片 -->
        <div class="login-right">
            <a-card class="login-card" :bordered="false">
                <h2 class="login-title">管理平台登录</h2>
                <p class="login-desc">赛事管理 · 报名审核 · 成绩积分</p>
                <a-form-model ref="loginForm" :model="form" :rules="rules">
                    <a-form-model-item prop="username">
                        <a-input v-model="form.username" placeholder="用户名" size="large" class="login-input">
                            <a-icon slot="prefix" type="user" />
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item prop="password">
                        <a-input-password v-model="form.password" placeholder="密码" size="large" class="login-input">
                            <a-icon slot="prefix" type="lock" />
                        </a-input-password>
                    </a-form-model-item>

                    <a-form-model-item prop="verifyCode">
                        <div style="display: flex">
                            <a-input v-model="form.verifyCode" placeholder="验证码" size="large" style="flex:1" class="login-input">
                                <a-icon slot="prefix" type="safety" />
                            </a-input>
                            <img :src="captchaSvg" class="captcha-box" @click="fetchCaptcha" alt="验证码" />
                        </div>
                    </a-form-model-item>

                    <a-button type="primary" block size="large" @click="handleLogin" :loading="loading" class="login-btn">登 录</a-button>
                </a-form-model>
            </a-card>
            <div class="login-footer">
                <span>桨刻体育 · 龙舟赛事数据资产平台</span>
                <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">粤ICP备2023117792号-3</a>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getCaptcha,
        login
    } from '@/api'

    export default {
        data() {
            return {
                captchaSvg: '',
                form: {
                    username: '',
                    password: '',
                    verifyKey: '',
                    verifyCode: ''
                },
                loading: false,
                rules: {
                    username: [{
                        required: true,
                        message: '请输入用户名',
                        trigger: 'blur'
                    }],
                    password: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    }],
                    verifyCode: [{
                        required: true,
                        message: '请输入验证码',
                        trigger: 'blur'
                    }]
                }
            }
        },
        created() {
            this.fetchCaptcha()
        },
        methods: {
            fetchCaptcha() {
                getCaptcha().then(res => {
                    if (res.data && res.data.img) {
                        this.captchaSvg = res.data.img;
                        this.form.verifyKey = res.data.verifyKey;
                    } else {
                        this.captchaSvg = res.img || (res.data && res.data.img);
                        this.form.verifyKey = res.verifyKey || (res.data && res.data.verifyKey);
                    }
                })
            },
            handleLogin() {
                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        this.loading = true
                        login(this.form).then(res => {
                            this.$store.commit('SET_TOKEN', res.data.token)
                            this.$message.success('登录成功')
                            this.$router.push('/')
                        }).catch(() => {
                            this.fetchCaptcha() // 失败刷新验证码
                        }).finally(() => {
                            this.loading = false
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .login-container {
        min-height: 100vh;
        background: linear-gradient(135deg, #16232F 0%, #1E3A4A 55%, #1F5F5B 130%);
        display: flex;
        position: relative;
        overflow: hidden;
    }

    .login-bg-wave {
        position: absolute;
        bottom: -30%;
        left: -10%;
        width: 120%;
        height: 60%;
        background: radial-gradient(ellipse at center, rgba(78, 205, 196, 0.18) 0%, transparent 70%);
    }

    .login-glow {
        position: absolute;
        border-radius: 50%;
        filter: blur(60px);
        opacity: 0.25;
    }

    .glow-1 {
        width: 360px;
        height: 360px;
        background: #4ECDC4;
        top: -80px;
        left: 30%;
    }

    .glow-2 {
        width: 300px;
        height: 300px;
        background: #F5A623;
        bottom: -100px;
        right: 12%;
        opacity: 0.12;
    }

    .login-left {
        flex: 1;
        padding: 64px 72px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-width: 640px;
        position: relative;
        z-index: 1;
    }

    .login-brand {
        display: flex;
        align-items: center;
        gap: 14px;
        margin-bottom: 64px;
    }

    .login-logo {
        width: 48px;
        height: 48px;
        border-radius: 13px;
        overflow: hidden;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 8px 20px rgba(78, 205, 196, 0.45);
    }

    .login-logo img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .login-brand-name {
        color: #fff;
        font-size: 22px;
        font-weight: 700;
        letter-spacing: 4px;
    }

    .login-brand-sub {
        background: linear-gradient(90deg, #4ECDC4, #B8FFF6, #4ECDC4, #2FBFB5, #4ECDC4);
        background-size: 220% auto;
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        font-size: 12px;
        letter-spacing: 2.5px;
        font-weight: 600;
        margin-top: 2px;
        animation: loginBrandGlow 4s linear infinite;
        filter: drop-shadow(0 0 6px rgba(78, 205, 196, 0.65));
    }

    @keyframes loginBrandGlow {
        0% { background-position: 0% center; }
        100% { background-position: 220% center; }
    }

    .login-logo {
        box-shadow: 0 8px 20px rgba(78, 205, 196, 0.45), 0 0 22px rgba(78, 205, 196, 0.35);
    }

    .login-slogan {
        color: #fff;
        font-size: 38px;
        font-weight: 800;
        line-height: 1.35;
        margin: 0 0 20px;
        letter-spacing: 2px;
    }

    .login-intro {
        color: #7AA3B5;
        font-size: 15px;
        line-height: 1.9;
        margin-bottom: 40px;
    }

    .login-contact {
        margin-top: 10px;
        color: #4ECDC4;
        font-size: 14px;
        letter-spacing: 1px;
        text-shadow: 0 0 10px rgba(78, 205, 196, 0.5);
    }

    .login-points {
        display: flex;
        gap: 28px;
        flex-wrap: wrap;
    }

    .login-point {
        color: #B8D3DE;
        font-size: 14px;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .login-point .anticon {
        color: #4ECDC4;
        font-size: 16px;
    }

    .login-right {
        width: 480px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 40px 48px;
        position: relative;
        z-index: 1;
    }

    .login-card {
        width: 100%;
        max-width: 400px;
        border-radius: 18px;
        box-shadow: 0 24px 70px rgba(0, 0, 0, 0.4);
        padding: 10px 6px;
        animation: cardIn 0.5s ease;
    }

    @keyframes cardIn {
        from { opacity: 0; transform: translateY(16px); }
        to { opacity: 1; transform: translateY(0); }
    }

    .login-title {
        text-align: center;
        margin-bottom: 4px;
        color: #16232F;
        font-size: 24px;
        font-weight: 700;
    }

    .login-desc {
        text-align: center;
        color: #7A8A9A;
        font-size: 13px;
        margin-bottom: 28px;
    }

    .login-input .ant-input-prefix {
        color: #A8B8C2;
    }

    .captcha-box {
        width: 148px;
        height: 48px;
        margin-left: 10px;
        cursor: pointer;
        background: #F4FAFA;
        display: block;
        object-fit: contain;
        border-radius: 8px;
        border: 1px solid #E4EDF2;
    }

    .login-btn {
        margin-top: 8px;
        border-radius: 10px;
        letter-spacing: 6px;
        height: 44px;
        font-size: 16px;
        background: linear-gradient(135deg, #4ECDC4, #2FBFB5);
        border: none;
        box-shadow: 0 8px 20px rgba(78, 205, 196, 0.4);
    }

    .login-btn:hover {
        background: linear-gradient(135deg, #3BB7AE, #2AA79E);
    }



    .login-footer {
        margin-top: 28px;
        color: #5E8295;
        font-size: 12px;
        display: flex;
        gap: 12px;
    }

    .login-footer a {
        color: inherit;
    }

    .login-footer a:hover {
        color: #4ECDC4;
    }

    @media (max-width: 960px) {
        .login-left { display: none; }
        .login-right { width: 100%; }
    }
</style>
